<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/04_Aspromonte/04_3_Gambarie-Area-Grecanica/04_3_Rocca-drako.jpg">
<div class="content">
    <h1>Aspromonte</h1>
    <h3>Area grecanica</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale dell’Aspromonte</a> > <a class="active">Area grecanica</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Gambarie-Area grecanica-Reggio Calabria</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/04_Aspromonte/04_3_Gambarie-Area-Grecanica/04_3_Rocca-drako.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Questo itinerario particolarmente avventuroso, parte da Gambarie d’Aspromonte a 1320 m di quota, stazione sciistica e turistica che gode 
            di magnifici paesaggi montani, come quelli del Bosco delle fate, e di affacci mozzafiato sullo Stretto e la Sicilia. 
            <br>
            <br>
            Nella prima tappa si raggiunge in discesa uno dei borghi storici più belli della Calabria, 
            quello di Pentedattilo (320 m), arroccato su un magnifico sperone roccioso, porta dell’area grecanica che si sviluppa intorno alla fiumara dell’Amendolea. 
            Si tratta di un borgo di grande bellezza pressoché disabitato, aggrappato a una incredibile parete rocciosa levigata dal vento che ricorda una grossa mano aperta. 
            <br>
            <br>
            Ripartiti da qui, raggiunta la costa jonica nel punto più estremo della penisola italiana, a Melito Porto Salvo, 
            si riprende a salire verso il centro abitato di Amendolea (185 m) toccando il noto Sentiero dell’Inglese, per poi raggiungere Bova, 
            uno dei Borghi più belli d’Italia. Qui occorre fermarsi per conoscere la Capitale della Calabria Greca, l’antica città di Bova, 
            considerata il centro dell’ellenofonia, ragione per cui si parla di Bovesìa per indicare l’Area Grecanica. Una delle ultime diocesi 
            italiane ad essere latinizzate dalla Chiesa Cattolica, Bova mantiene pressoché intatto il suo magnifico centro storico che si sviluppa 
            intorno al castello Normanno da cui si gode una vista sconfinata sulla costa jonica e lo Stretto. Fra i tanti monumenti si segnala la Chiesa 
            di San Leo con la cappella che custodisce le reliquie del Santo asceta, venerato a Bova e Africo che lo festeggiano rispettivamente il 5 e l’11 maggio. 
            Irrinunciabili i formaggi caprini, freschi o stagionati, questi formaggi regalano vere e proprie emozioni gustative. Da non perdere anche la Lestopitta, 
            una sorta di pane sottile dall’impasto estremamente semplice che viene fritto e farcito con i prodotti locali, dai salumi, ai formaggi alle verdure. 
            Anche il pecorino dell’area grecanica ha una sua singolare tradizione, quella della “musulupa”, uno stampo in legno che si utilizza per creare formaggi 
            dalle sembianze antropomorfe. 
            <br>
            <br>
            Nella seconda tappa si riparte da Bova (820 m) salendo fino a quota 1243 m per addentrarsi in un’area connotata da geositi stupefacenti 
            come quelli di Rocca del Drako e delle Caldaie del Latte, nei pressi di Roghudi vecchio. Superata la fiumara dell’Amendolea si raggiunge 
            Roccaforte del Greco (945 m) e da qui si riparte per fare rientro a Gambarie (1320 m).          
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>84 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>3</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>3440 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>3440 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Gambarie d’Aspromonte</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Gambarie d’Aspromonte</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-10 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
